import { getCookie } from "@/utils/cookies"

export default {
  async checkUnreadMessages({ state, commit }) {
    const access = getCookie("auth_access_mpo")
    const url = `${new URL(process.env.VUE_APP_MESSENGER_URL_XHR).origin}/api/v2`

    const res = await fetch(`${url}/chats/messages/unread-count/?sender=seller`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`
      }
    })
    const { count } = await res.json()

    commit("SET_TOTAL_UNREAD_COUNT", count)
  }
}
